import { EquipmentService } from '#services/api';
import { ToasterService } from '#services/shared';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Role } from 'enums';
import { Equipment, Filter } from 'models';
import { Drawing } from 'models/drawing';
import { take } from 'rxjs/operators';
import { CommonHelper } from '_extentions/common-helper';
import { EquipmentDrawingCreateArgs, EquipmentDrawingCreateDialogComponent } from '../equipment-drawing-create-dialog/equipment-drawing-create-dialog.component';

@Component({
  selector: 'app-equipment-drawing',
  templateUrl: './equipment-drawing.component.html',
  styleUrls: ['./equipment-drawing.component.scss'],
  standalone: false
})

export class EquipmentDrawingComponent implements OnInit {
  @Input() equipment: Equipment;
  drawings: Drawing[];
  orgDrawings: Drawing[];
  visibleDrawings: Drawing[] = [];
  filter: Filter = <Filter>{};
  Role = Role;
  canaddDrawing: boolean = false;

  private lastDrawingsRef: Drawing[] = null;
  private lastTypeId: number = undefined;

  public drawingColumnsToDisplay: Map<string, string> = new Map([
    ['Name', 'Drawing Name'],
    ['DocumentName', 'Link to document'],
    ['Tag', ''],
    ['IsDisabled', 'Status'],
    ['Remove', '']
  ]);

  constructor(
    public dialog: MatDialog,
    private toaster: ToasterService,
    private equipmentService: EquipmentService
  ) { }

  ngOnInit() {
    this.initDrawing();
  }

  get pendingFiles(): File[] {
    return (this.equipment && this.equipment.DirectDrawingFiles) || [];
  }

  onFileDropped(file: File) {
    if (!file) {
      return;
    }

    if (!this.equipment.DirectDrawingFiles) {
      this.equipment.DirectDrawingFiles = [];
    }

    const alreadyQueued = this.equipment.DirectDrawingFiles
      .some(f => f.name === file.name && f.size === file.size);

    if (alreadyQueued) {
      this.toaster.showWarn('Warning...', `'${file.name}' is already in the upload list.`);
      return;
    }

    this.equipment.DirectDrawingFiles.push(file);
  }

  removePendingFile(file: File) {
    if (!this.equipment.DirectDrawingFiles) {
      return;
    }

    this.equipment.DirectDrawingFiles =
      this.equipment.DirectDrawingFiles.filter(f => f !== file);
  }

  initDrawing() {
    const equipmentId = this.equipment && this.equipment.ID;
    if (!equipmentId) {
      return;
    }

    this.equipmentService
      .getDrawing(equipmentId)
      .pipe(
        take(1)
      )
      .subscribe(data => {      
        this.drawings = data;
        this.orgDrawings = CommonHelper.deepCopy(this.drawings);
        this.equipment.AssignedDrawing = this.drawings;
      });

  }


  onAddDrawing() {
    this.canaddDrawing = true;
    if (!this.equipment || !this.equipment.EquipmentTypeID) {
      this.canaddDrawing = false;
      this.toaster.showWarn('Warning...', 'Please set equipment Type');
    }
    else {
      const selectedItems = this.drawings && this.drawings.length > 0 ? this.drawings.filter(i => i.IsDisabled == false) : [];
      const args: EquipmentDrawingCreateArgs = {
        equipment: this.equipment,
        selectedDrawing: selectedItems
      };

      const dialogRef = this.dialog.open(EquipmentDrawingCreateDialogComponent, {
        width: '50%',
        maxHeight: '90%',
        minWidth: '400px',
        minHeight: '200px',
        data: args
      });

      dialogRef.afterClosed().subscribe(async (result: any) => {
        if (result) {
          
          const standalone = (this.drawings || [])
            .filter(d => !d.EquipmentTypes || d.EquipmentTypes.length === 0);
          const merged = [...standalone, ...result];

          this.drawings = merged;
          this.equipment.AssignedDrawing = merged;
          this.toaster.showSuccess('Success...', 'Drawing changes has been saved.');
        }
      });
    }
  }

  get canShowDrawings() {
    this.recomputeVisibleDrawings();
    return this.visibleDrawings && this.visibleDrawings.length > 0;
  }

  private recomputeVisibleDrawings() {
    const typeId = this.equipment ? this.equipment.EquipmentTypeID : null;

    
    if (this.drawings === this.lastDrawingsRef && typeId === this.lastTypeId) {
      return;
    }

    this.lastDrawingsRef = this.drawings;
    this.lastTypeId = typeId;

    
    this.visibleDrawings = (this.drawings || []).filter(d =>
      !d.EquipmentTypes ||
      d.EquipmentTypes.length === 0 ||
      d.EquipmentTypes.some(t => t.ID === typeId));
  }

  onKey(event) {
    this.filter = <Filter>{
      search: event.target.value
    };
  }

  async onRemoveDrawing(item: Drawing) {
    if (!item) {
      return;
    }

    const equipmentId = this.equipment && this.equipment.ID;

    if (equipmentId > 0) {
      try {
        await this.equipmentService.removeDrawing(equipmentId, item.ID).toPromise();
      } catch {
        this.toaster.showError('Error...', 'Drawing could not be removed.');
        return;
      }
    }

    this.drawings = (this.drawings || []).filter(d => d.ID !== item.ID);
    this.orgDrawings = (this.orgDrawings || []).filter(d => d.ID !== item.ID);
    this.equipment.AssignedDrawing = this.drawings;
    this.toaster.showSuccess('Success...', `'${item.Name}' has been removed.`);
  }
}
